import { defaultBreakpoints } from '../../system/tokens';
import { setImagePreload } from '../Image/image.utils';
export const getMediaQuery = (sources, breakpoint) => {
    const breakpointIndex = breakpointKeys.indexOf(breakpoint);
    if (breakpoint === 'xs') {
        return `(max-width: ${sumPx(defaultBreakpoints.sm, -1)})`;
    }
    const hasGreater = sources.some(({ breakpoint: sourceBreakpoint }) => breakpointKeys.indexOf(sourceBreakpoint) > breakpointIndex);
    return hasGreater
        ? `(min-width: ${defaultBreakpoints[breakpoint]}) and (max-width: ${sumPx(defaultBreakpoints[breakpointKeys[breakpointIndex + 1]], -1)})`
        : `(min-width: ${defaultBreakpoints[breakpoint]})`;
};
export const getRetinaReadySrcSet = ({ src, width, quality, priority, imageLoader, sources, breakpoint }) => {
    const src1x = imageLoader({ src, width, quality });
    const src2x = imageLoader({ src, width: width * 2, quality });
    const srcSet = `${src1x} 1x, ${src2x} 2x`;
    if (priority) {
        setImagePreload({
            srcSet,
            href: src1x,
            media: getMediaQuery(sources, breakpoint),
            fetchPriority: 'high'
        });
    }
    return srcSet;
};
const breakpointKeys = Object.keys(defaultBreakpoints);
const sumPx = (a, b) => `${Number(a.replace('px', '')) + b}px`;
